

export default {
  mails: [],
  mail_filter: null,
  mailTags: [],
  meta: {},
  mailSearchQuery: ''
}
